import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { isNil } from "lodash";
import { Coordinates } from "@evergis/sgis/es/baseTypes";
import { PositionDc } from "@evergis/api";

import { reset, setMapView } from "../../ducks/mapView/mapView";
import { useProjectInfo } from "../../ducks/project/hooks";
import { useIsDashboard } from "../location/useIsDashboard";
import { useIsProjectEditable } from "./useIsProjectEditable";
import { useIsShared } from "../api/useIsShared";

type SyncMapViewData = {
  position?: Coordinates | PositionDc | number[];
  resolution?: number;
};

interface SyncProjectViewOptions {
  update?: VoidFunction;
}

export function useSyncProjectView(syncMapViewData: SyncMapViewData, options: SyncProjectViewOptions = {}) {
  const dispatch = useDispatch();
  const { position, resolution } = syncMapViewData || {};
  const { update } = options;
  const isInitialSync = useRef<boolean>(true);
  const [project] = useProjectInfo();
  const isDashboard = useIsDashboard();
  const isShared = useIsShared();
  const isProjectEditable = useIsProjectEditable();

  useEffect(() => {
    if (isDashboard || isShared) return;

    if (isNil(position) || isNil(resolution)) {
      isInitialSync.current = true;

      return;
    }

    if (isInitialSync.current) {
      dispatch(
        setMapView({
          // TODO
          position: position as Coordinates,
          resolution,
        }),
      );

      dispatch(reset());

      isInitialSync.current = false;
    } else if (isProjectEditable) {
      if (
        (project.content.position[0] === position[0] &&
          project.content.position[1] === position[1] &&
          project.content.resolution === resolution) ||
        position.filter(Boolean).length < 2
      ) {
        return;
      }

      update?.();
    }
  }, [position, resolution]); // eslint-disable-line
}
